import { useLazyAuthControllerLogoutQuery } from '@app/api/auth-api';
import { Button, ButtonStyle } from '@app/components/button/button';
import { useAppDispatch, useEnhancedTranslation } from '@app/hooks';
import { removeToken } from '@app/features/auth';
import { loggedOut } from '@app/store/reducers/authSlice';
import { useMemo } from 'react';

type TLogoutButton = 'navbar-link' | 'personal-info' | 'account-page-tab';
interface ILogoutButtonProps {
  type?: TLogoutButton | undefined | null;
}

export const LogoutButton = ({ type = null }: ILogoutButtonProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const { t } = useEnhancedTranslation({ keyPrefix: 'account.personalInfo' });
  const [logout] = useLazyAuthControllerLogoutQuery();

  const handleLogout = async (): Promise<void> => {
    const resp = await logout();
    if (resp.isSuccess) {
      dispatch(loggedOut());
      removeToken();
    }
  };

  const classButton = useMemo(() => {
    switch (type) {
      case 'navbar-link':
        return 'button--navbar-link';
      case 'personal-info':
        return 'personal-info-tab__logout-btn';
      case 'account-page-tab':
        return 'button--account-page-tab';
      default:
        return '';
    }
  }, [type]);

  return (
    <Button
      styling={ButtonStyle.ARROW}
      className={classButton}
      onClick={handleLogout}
      size={{ icon: 'small', text: 'medium' }}
    >
      {t('logOut')}
    </Button>
  );
};
